const adminPage            = require('./admin-page')

export function start(detail){  //console.log('nurses-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      page:            { start: (detail)=>{  adminPage.start(detail)             }},
}/**/